module.exports = __webpack_public_path__ + "img/KinokoTable34.921ab9dc.jpg";